<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import EventBus from '@/utils/event-bus';

moment.locale('zh-cn');
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    };
  },
  created() {
    // EventBus.$on('ExpiredAuthorization', () => {
    //   this.$router.replace({
    //     path: '/login',
    //     query: {
    //       redirect: this.$route.path,
    //     },
    //   });
    // });
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
  background: #fff;
}
</style>
